import React, { Component } from 'react';
import axios from 'axios';
import API_URL from './config';

import {
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavbarToggler,
  MDBCollapse,
  MDBNavItem,
  MDBFooter,
  MDBNavLink,
  MDBIcon
} from 'mdbreact';
import Logo from './pages/LogoRemuneraciones.png';
import { BrowserRouter as Router, withRouter } from 'react-router-dom';
import Routes from './Routes';
import { puede, esTrabajador } from './permisos';
import './App.css';

const INACTIVITY_TIMEOUT_TRABAJADOR = 10 * 60 * 1000;   // 10 minutos
const INACTIVITY_TIMEOUT_ADMIN     = 8 * 60 * 60 * 1000; // 8 horas
const INACTIVITY_TIMEOUT_OPERADOR  = 5 * 60 * 60 * 1000; // 5 horas

class App extends Component {
  state = {
    collapseID: ''
  };

  inactivityTimer = null;

  // 11/08/2026 - el tiempo de inactividad se decide por los modulos que tiene
  // concedidos, no por una cadena de rol fija. Quien administra el sistema
  // dispone de mas tiempo; quien solo despacha boletas con comprobante, menos.
  getInactivityTimeout = () => {
    try {
      var datos = JSON.parse(sessionStorage.getItem('datos'));
      if (datos && datos[0]) {
        if (puede(datos, 'GESTION_USUARIOS') || puede(datos, 'GESTION_COMPROBANTES') ||
            puede(datos, 'CONTROL_DESCARGAS') || puede(datos, 'DJ_GESTION')) {
          return INACTIVITY_TIMEOUT_ADMIN;
        }
        if (puede(datos, 'BOLETAS_COMPROBANTE') || puede(datos, 'BOLETAS_ADMIN')) {
          return INACTIVITY_TIMEOUT_OPERADOR;
        }
      }
    } catch(e) {}
    return INACTIVITY_TIMEOUT_TRABAJADOR;
  };

  resetInactivityTimer = () => {
    if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
    if (sessionStorage.getItem('datos')) {
      this.inactivityTimer = setTimeout(() => {
        sessionStorage.clear();
        window.location.replace('/');
      }, this.getInactivityTimeout());
    }
  };

  componentDidMount() {
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach(ev => window.addEventListener(ev, this.resetInactivityTimer));
    this.resetInactivityTimer();
  }

  componentWillUnmount() {
    if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach(ev => window.removeEventListener(ev, this.resetInactivityTimer));
  }

  toggleCollapse = collapseID => () =>
    this.setState(prevState => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : ''
    }));

  closeCollapse = collapseID => () => {
    axios.get(`${API_URL}/borrarsesion/`)
      .then((response) => this.setState({ collapseID: '' }))
      .catch();

    window.scrollTo(0, 0);
    this.state.collapseID === collapseID && this.setState({ collapseID: '' });
  };

  render() {
    const overlay = (
      <div
        id='sidenav-overlay'
        style={{ backgroundColor: 'transparent' }}
        onClick={this.toggleCollapse('mainNavbarCollapse')}
      />
    );

    const { collapseID } = this.state;

    // 12/08/2026 - El Router llevaba basename='/remuneraciones', que es lo que
    // dejaba direcciones como remuneraciones.unsaac.edu.pe/remuneraciones/ con
    // la palabra repetida. Ahora la aplicación vive en la raíz del dominio;
    // nginx redirige las direcciones antiguas para no romper favoritos.
    return (
      <Router>
        <div className='flyout'>
          <MDBNavbar style={{
            background: 'linear-gradient(135deg, #7A1622 0%, #5C1019 100%)',
            fontFamily: "'Roboto', sans-serif",
            fontSize: "0.95rem",
            fontWeight: 500,
            borderBottom: '3px solid #D4A843',
            boxShadow: '0 2px 12px rgba(0,0,0,0.3)'
          }} dark expand='md' fixed='top' scrolling>
            <MDBNavbarBrand href='/' className='py-0 font-weight-bold'>
              <img src={Logo} alt="Logo" style={{
                height: '3.2rem',
                width: '3.2rem',
                borderRadius: '50%',
                objectFit: 'contain'
              }} />
              <span className='ml-2' style={{ display: 'inline-flex', flexDirection: 'column', lineHeight: '1.2' }}>
                <strong style={{ fontSize: '1.1rem', color: '#fff' }}>Sub Unidad de Remuneraciones</strong>
                <small style={{ fontSize: '0.72rem', color: '#D4A843', letterSpacing: '1px' }}>UNSAAC</small>
              </span>
            </MDBNavbarBrand>
            <MDBNavbarToggler
              onClick={this.toggleCollapse('mainNavbarCollapse')}
            />
            <MDBCollapse
              id='mainNavbarCollapse'
              isOpen={this.state.collapseID}
              navbar
            >
              <NavItems closeCollapse={this.closeCollapse} />
            </MDBCollapse>
          </MDBNavbar>
          {collapseID && overlay}
          <main style={{ marginTop: '4rem' }}>
            <Routes />
          </main>
          <MDBFooter style={{
            background: 'linear-gradient(135deg, #7A1622 0%, #5C1019 100%)',
            borderTop: '3px solid #D4A843',
            fontFamily: "'Roboto', sans-serif",
            fontSize: "1rem",
            fontWeight: 500
          }}>
            <p className='footer-copyright mb-0 py-3 text-center'>
              &copy; {new Date().getFullYear()} Copyright:
              Sub Unidad de Remuneraciones
            </p>
          </MDBFooter>
        </div>
      </Router>
    );
  }
}

const NavItemsBase = ({ location, closeCollapse }) => {
  const path = location.pathname;
  const publicPages = ['/', '/recuperar-contrasena'];
  const isPublic = publicPages.includes(path);
  const isDashboard = path === '/dashboard';
  const isInternal = !isPublic && !isDashboard;

  let primerNombre = '';
  // 11/08/2026 - "Mi dashboard" es la pantalla del trabajador. Se ofrece solo
  // a quien no tiene modulos administrativos, en vez de mirar esAdmin/rol.
  let esPersonalOficina = false;
  if (!isPublic) {
    try {
      const datos = JSON.parse(sessionStorage.getItem('datos'));
      if (datos && datos[0] && datos[0].nombres) {
        primerNombre = datos[0].nombres.trim().split(' ')[0];
        primerNombre = primerNombre.charAt(0).toUpperCase() + primerNombre.slice(1).toLowerCase();
      }
      esPersonalOficina = !esTrabajador(datos);
    } catch (e) {}
  }

  return (
    <MDBNavbarNav right>
      {!isPublic && primerNombre && (
        <MDBNavItem className='d-flex align-items-center'>
          <span style={{
            color: '#D4A843',
            fontSize: '0.88rem',
            fontWeight: 500,
            marginRight: '0.5rem',
            whiteSpace: 'nowrap'
          }}>
            <MDBIcon icon='user-circle' className='mr-1' />
            Bienvenido(a), {primerNombre}
          </span>
        </MDBNavItem>
      )}
      {!isPublic && primerNombre && (
        <MDBNavItem className='nav-separator d-none d-md-block' />
      )}
      {isInternal && !esPersonalOficina && (
        <MDBNavItem>
          <MDBNavLink
            to='/dashboard'
            onClick={(e) => {
              e.preventDefault();
              window.location.replace('/dashboard');
            }}
            className='nav-item-custom'
          >
            <MDBIcon icon='home' className='mr-1' />
            Inicio
          </MDBNavLink>
        </MDBNavItem>
      )}
      {!isPublic && (
        <MDBNavItem>
          <MDBNavLink
            onClick={() => {
              closeCollapse('mainNavbarCollapse');
              sessionStorage.clear();
              window.location.replace('/');
            }}
            to='#'
            className='nav-item-salir'
          >
            <MDBIcon icon='sign-out-alt' className='mr-1' />
            Salir
          </MDBNavLink>
        </MDBNavItem>
      )}
    </MDBNavbarNav>
  );
};

const NavItems = withRouter(NavItemsBase);

export default App;
